import {
  type GraphEdgeSettings,
  type GraphEdgeSettingsId,
  isGroupEdgeSettings,
} from '@ipfabric/utils';
import type { Draft } from 'immer';
import type { GraphState } from '../GraphState';

const getEdge = (
  group: GraphEdgeSettings,
  edgeSettingsId: GraphEdgeSettingsId,
) => {
  if (group.id === edgeSettingsId) {
    return group;
  }
  if (isGroupEdgeSettings(group)) {
    return group.children.find(({ id }) => id === edgeSettingsId);
  }
  return undefined;
};

export const setEdgeProps = (
  draft: Draft<GraphState>,
  prop: 'grouped' | 'visible',
  value: boolean,
  edgeSettingsId: GraphEdgeSettingsId,
): void => {
  const {
    presetDraft: { edges },
  } = draft.layoutSettings;
  const foundGroup = edges.find(
    (edge) =>
      edge.id === edgeSettingsId ||
      (isGroupEdgeSettings(edge) &&
        edge.children.some((child) => child.id === edgeSettingsId)),
  );

  if (!foundGroup) {
    return;
  }

  const foundEdge = getEdge(foundGroup, edgeSettingsId);

  if (foundEdge) {
    foundEdge[prop] = value;
  }
};
